/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Stocktake_Submit_Dialog_AfterInputs */

const vi_stocktake_submit_dialog_after = /** @type {(inputs: Stocktake_Submit_Dialog_AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sau khi submit, kế toán duyệt sẽ tự sinh 1 PNK + 1 PXK gộp`)
};

/**

* @param {Stocktake_Submit_Dialog_AfterInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const stocktake_submit_dialog_after = /** @type {((inputs?: Stocktake_Submit_Dialog_AfterInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stocktake_Submit_Dialog_AfterInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_stocktake_submit_dialog_after(inputs)
});